<template>
    <v-container fluid>
        <v-card class="mb-4">
            <v-card-title class="justify-center"> 
                <h3 class="card-title">Gestión de Tratamientos</h3>
            </v-card-title>
            <v-divider/>
            <v-card-text>
                <!-- fitlros -->
                <div class="filtros">
                    <div>
                        <v-select
                            :items="resources.modelos"
                            item-text="nombre"
                            item-value="id"
                            label="Selecciona modelo producto"
                            v-model="filtros.modelo_producto_id"
                            @change="handleChangeModeloProducto"
                        />
                    </div>
                    <div>
                        <v-select
                            :items="resources.tiposLuna"
                            item-text="nombre"
                            item-value="idtipo_luna"
                            label="Tipo de luna"
                            v-model="filtros.tipo_luna_id"
                            clearable
                        />
                    </div>
                    <div class="filtros-acciones">
                        <v-btn color="primary" @click="getRelaciones">
                            Aplicar filtros
                        </v-btn>
                        <v-btn color="secondary" @click="resetFiltros">
                            Limpiar filtros
                        </v-btn>
                    </div>
                </div>

            </v-card-text>
        </v-card>

        <v-card v-if="relaciones.length > 0">
            <v-card-title class="justify-center"> 
                <h3 class="card-title">Relaciones de Tratamientos</h3>
            </v-card-title>
            <v-divider/>
            <v-card-text>
                <TreeRelaciones
                    :tratamientos="resources.tratamientos"
                    :subRelaciones="relaciones"
                    :showSubRelaciones="true"
                    :isSunGlasses="isSunGlasses"
                />
            </v-card-text>
        </v-card>


        <!-- Modal nueva relacion -->
        <ModalCard
            v-model="addRelacion.show"
            max-width="1200px"
            @cancel="resetModal('addRelacion')"
            >
            <template #title>
                <v-icon left>mdi-plus</v-icon>
                Añadir Relación
            </template>
            <FormRelacion
                class="p-form"
                :tratamientos="resources.tratamientos"
                :modales="resources.modales"
                :relacion="addRelacion.relacion"
                @submit="handleStoreRelacion"
                @cancel="resetModal('addRelacion')"
                @add:tratamiento="handleAddTratamiento"
                @add:modal="handleAddTratamientoModal"
            />
        </ModalCard>

        <!-- Modal editar relacion -->
        <ModalCard
            v-model="editRelacion.show"
            max-width="900px"
            @cancel="resetModal('editRelacion')"
            >
            <template #title>
                <v-icon left>mdi-pencil</v-icon>
                Editar Relación #{{ editRelacion.relacion?.code || '' }}
            </template>
            <FormRelacion
                class="p-form"
                :tratamientos="resources.tratamientos"
                :modales="resources.modales"
                :relacion="editRelacion.relacion"
                @submit="handleUpdateRelacion"
                @cancel="resetModal('editRelacion')"
                @add:tratamiento="handleAddTratamiento"
                @add:modal="handleAddTratamientoModal"
            />
        </ModalCard>

        <!-- Modal eliminar relacion -->
        <ModalDelete
            v-model="deleteRelacion.show"
            @destroy="handleDestroyRelacion"
            @cancel="resetModal('deleteRelacion')"
        />


        <!-- Modal nuevo tratamiento -->
        <ModalCard
            v-model="modal.addTratamiento.show" 
            max-width="900px"
            @cancel="resetModalsAdd('addTratamiento')"
            >
            <template #title>
                <v-icon left>mdi-plus</v-icon>
                Nuevo Tratamiento
            </template>

            <FormTratamiento
                class="p-form"
                v-model="modal.addTratamiento.tratamiento"
                @submit="handleStoreTratamiento"
                @cancel="resetModalsAdd('addTratamiento')"
            />
        </ModalCard>

       
        <!-- Modal nuevo tratamiento modal -->
        <ModalCard
            v-model="modal.addTratamientoModal.show"
            max-width="900px"
            @cancel="resetModalsAdd('addTratamientoModal')"
            >
            <template #title>
                <v-icon left>mdi-plus</v-icon>
                Nuevo Tratamiento Modal
            </template>

            <FormTratamientoModal
                class="p-form"
                v-model="modal.addTratamientoModal.tratamientoModal"
                @submit="handleStoreTratamientoModal"
                @cancel="resetModalsAdd('addTratamientoModal')"
            />
        </ModalCard>


    </v-container>
</template>


<script>
import { tratamiento } from '@/models/tratamiento';
import { tratamientoModal } from '@/models/tratamientoModal';

import tratamientoService from '@/services/tratamientoService';
import tratamientoRelacionService from '@/services/tratamientoRelacionService';
import tratamientoModalService from '@/services/tratamientoModalService';

import ActionsTratamientos from '@/components/tratamientos/ActionsTratamientos.vue';
import ModalCard from '@/components/ModalCard.vue';
import ModalDelete from '@/components/ModalDelete.vue';

import TreeRelaciones from '@/components/tratamientos/relacion/TreeRelaciones.vue';
import FormRelacion from '@/components/tratamientos/relacion/FormRelacion.vue';

import FormTratamiento from '@/components/tratamientos/tratamiento/FormTratamiento.vue';
import FormTratamientoModal from '@/components/tratamientos/modal/FormTratamientoModal.vue';
import { mapState, mapActions } from 'vuex';


const modals = _ => ({
    addTratamiento: {
        show: false,
        tratamiento: null,
    },

    addTratamientoModal: {
        show: false,
        loading: false,
        tratamientoModal: null,
    },
})


const MODELO_PRODUCTO = {
    OPTICOS_ID: 2,
    SOL_ID: 3,
};

export default {
    name: 'TratamientosPanel',
    components: {
        ActionsTratamientos,
        ModalCard,
        ModalDelete,

        TreeRelaciones,
        FormRelacion,

        FormTratamiento,

        FormTratamientoModal,
    },
    data() {
        return {
            resources: {
                modelos: [
                    { id: MODELO_PRODUCTO.OPTICOS_ID, nombre: 'Opticos y Deportivos' },
                    { id: MODELO_PRODUCTO.SOL_ID, nombre: 'Sol' },
                ],
                tratamientos: [],
                modales: [],
                tiposLuna: [],
            },
            relaciones: [],
            filtros: {
                modelo_producto_id: null,
                tipo_luna_id: null,
            },
            modal: modals(),
        }
    },
    computed: {
        ...mapState('relaciones', [
            'addRelacion',
            'editRelacion',
            'deleteRelacion',
        ]),

        isSunGlasses() {
            return this.filtros.modelo_producto_id === MODELO_PRODUCTO.SOL_ID;
        }
    },
    methods: {
        ...mapActions('relaciones', [
            'resetModal'
        ]),

        async handleChangeModeloProducto() {
            const tiposLunasResponse = await tratamientoRelacionService.getTiposLunas(this.filtros.modelo_producto_id);
            this.resources.tiposLuna = tiposLunasResponse.data;
            this.filtros.tipo_luna_id = null;

        },
        async fetchPageData() {
            try {
                const [
                    tratamientosResponse,
                    modalesResponse
                ] = await Promise.all([
                    tratamientoRelacionService.getTratamientos(),
                    tratamientoRelacionService.getModales()
                ]);                
                
                this.resources.tratamientos = tratamientosResponse.data;
                this.resources.modales = modalesResponse.data;

            } catch (error) {   
                this.handleErrorApi(error);
            }
        },

        async fetchRelaciones() {
            try {
                const response = await tratamientoRelacionService.getAll(this.filtros);
                
                this.relaciones = response.data;
            } catch (error) {   
                this.handleErrorApi(error);
            }
        },

        getRelaciones() {
            this.$store.dispatch('relaciones/setFiltros', this.filtros);
            this.fetchRelaciones();
        },
        resetFiltros() {
            this.fetchPageData();

            this.filtros.modelo_producto_id = null;
            this.filtros.tipo_luna_id = null;
            this.$store.dispatch('relaciones/setFiltros', this.filtros);
            
            this.relaciones = [];
        },

        async fetchTratamientos() {
            try {
                const response = await tratamientoRelacionService.getTratamientos()
                
                this.resources.tratamientos = response.data;
            } catch (error) {
                this.handleErrorApi(error);
            }
        },
        async fetchModales() {
            try {
                const response = await tratamientoRelacionService.getModales()
                
                this.resources.modales = response.data;
            } catch (error) {
                this.handleErrorApi(error);
            }
        },


        async handleStoreRelacion(relacion) {

            try {
                await tratamientoRelacionService.store(relacion);

                this.$toasted.success('Relación creada correctamente.');
                this.getRelaciones();
                this.resetModal('addRelacion');
                
            } catch (error) {
                this.handleErrorApi(error);
            }
            
        },
        async handleUpdateRelacion(relacion) {
            try {
                await tratamientoRelacionService.update(relacion.id, relacion);

                this.$toasted.success('Relación actualizada correctamente.');

                this.getRelaciones();
                this.resetModal('editRelacion');

            } catch (error) {
                this.handleErrorApi(error);
            }
        },
        async handleDestroyRelacion() {
            try {
                const relacion = this.deleteRelacion.relacion;
                await tratamientoRelacionService.destroy(relacion.id);

                this.$toasted.success('Relación eliminada correctamente.');
                
                this.getRelaciones();
                this.resetModal('deleteRelacion');
                this.resetModal('editRelacion');
            } catch (error) {
                this.handleErrorApi(error);
            }
        },



        handleAddTratamiento() {
            this.modal.addTratamiento.tratamiento = {...tratamiento };
            this.modal.addTratamiento.show = true;
        },
        async handleStoreTratamiento(form) {

            try {

                const formData = new FormData();
                for (const key in form) {
                    if (form[key] !== undefined && form[key] !== null) {
                        formData.append(key, form[key]);
                    }
                }

                const response = await tratamientoService.store(formData);
                
                await this.fetchTratamientos();
                this.resetModalsAdd('addTratamiento');
                this.$toasted.success('Tratamiento creado correctamente.');

            } catch (error) {
                this.handleErrorApi(error);
            }
        },



        handleAddTratamientoModal() {
            this.modal.addTratamientoModal.tratamientoModal = {...tratamientoModal };
            this.modal.addTratamientoModal.show = true;
        },
        async handleStoreTratamientoModal(form) {

            try {

                const formData = new FormData();
                for (const key in form) {
                    if (form[key] !== undefined && form[key] !== null) {
                        formData.append(key, form[key]);
                    }
                }

                const response = await tratamientoModalService.store(formData);
                
                await this.fetchModales();
                this.resetModalsAdd('addTratamientoModal');
                this.$toasted.success('Modal creado correctamente.');

            } catch (error) {
                this.handleErrorApi(error);
            }
        },


        resetModalsAdd(modalName) {
            const modales = modals();

            if ( !modales.hasOwnProperty(modalName) ) {
                console.warn(`El modal ${modalName} no existe.`);
                return;
            }

            this.modal[modalName] = modales[modalName];
        }


    },
    mounted() {
        this.fetchPageData();
    },
}
</script>

<style scoped>

.filtros {
    display: grid;
    grid-template-columns: repeat(3, minmax(250px, 1fr));
    gap: 16px;
}
.filtros-acciones{
    display: flex;
    align-items: center;
    gap: 8px;
}

.relaciones-container{
    overflow-x: auto;
    background: rgba(255, 255, 255, 0.1);
}

.p-form {
    padding: 16px;
}




</style>